import PropTypes from 'prop-types';
import React from 'react';
import InstructionsView from 'components/tools/InstructionsView';

const Instructions = ({nextView}) => <InstructionsView
  onSubmit={nextView}
  title='tools.multiple.identify.merge'
  remember={[
    'tools.multiple.show.accounts',
    'tools.multiple.filter.systems',
    'tools.multiple.water.test',
    'tools.multiple.system.merge',
  ]}
  instructions={[
    {
      title: 'tools.instructions.run.report',
      body: 'tools.multiple.start.list',
    },
    {
      title: 'tools.instructions.review.report',
      body: 'tools.multiple.account.review',
    },
    {
      title: 'tools.multiple.complete.merge',
      body: 'tools.multiple.select.master',
    },
  ]}
/>;

Instructions.propTypes = {
  nextView: PropTypes.func.isRequired,
};

export default Instructions;
